import React from 'react'
import Map from "../Map/map"
import { CustomMarker } from '../Map/bmarker';
import {connect} from 'react-redux' 

const StoreMap = ({details})  => (
    <Map 
        center={
            details.fetching ? null : details.data ?  
            {
                lat: parseFloat(details.data.latitude),
                lng: parseFloat(details.data.longitude)
            } : null
        } 
    > 
        {
            details.fetching ? null : details.data ?
            <CustomMarker 
                type="S" 
                position={{
                    lat: parseFloat(details.data.latitude),
                    lng: parseFloat(details.data.longitude)
                }}
            /> : null    
        }
    </Map>
)

const mapStateToProps = ({storeDetails }) => ({
    details: storeDetails
})

export default connect(mapStateToProps)(StoreMap)